module.exports = __webpack_public_path__ + "img/imposta-logo-easyer.3ba26059.png";